import CtaButton from '#src/components/CtaButton';
import { selectContentType } from '#src/lib/contentful/selectors.mjs';
import { interpolateFields } from '#src/lib/env-interpolation.js';

import { CardCta } from './CardCta';

const ctaTypeMap = {
  link: CtaButton,
  hubCard: CardCta,
};

export function CTA({ cta, ...props }) {
  const typeId = selectContentType(cta);
  const CtaComponent = ctaTypeMap[typeId];
  return !CtaComponent ? null : (
    <div>
      <CtaComponent cta={interpolateFields(cta)} {...props} />
    </div>
  );
}
